import React from "react"
import ListCard from "../ListCard"
import "./NeedsABoostCard.scss"

const NeedsABoostCard = props => {
  return (
    <div className="NeedsABoostCard">
      <ListCard dataSort="ASC" {...props}>
        Needs a Boost
      </ListCard>
    </div>
  )
}

NeedsABoostCard.propTypes = {
  entityType: ListCard.propTypes.entityType,
  entityId: ListCard.propTypes.entityId,
}

export default NeedsABoostCard
